module.exports = __webpack_public_path__ + "img/product_124.6d8eb42.webp";